import { Component, EventEmitter, Output, Input, ViewEncapsulation } from '@angular/core';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import { BaseComponent } from 'app/shared/infrastructure/base.component';
import MicroChart from "../micro-chart";
import { QueryGeneratorService } from 'app/shared/services/query-builder';
import { GeneratorType, ChartType } from 'app/shared/models/enum/query-builder';

@Component({
  selector: 'dashboard-generator-cmp',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./dashboard-generator.scss'],
  templateUrl: './dashboard-generator.html'
})
export class DashboardGeneratorComponent extends BaseComponent {

  _widgets: any[] = [];
  _microChart: MicroChart = new MicroChart();
  viewSettingScreen: boolean = false;
  selectedWidgetSize: any = null;
  widgetSizes: any[] = [];
  selectedItem: any = null;
  @Output() onSetResult = new EventEmitter<any>();
  @Input() public set widgets(value: any[]) {

    if (value) {
      let items = value;
      if (items.length === 0) {
        this._widgets = [];
      } else {
        items.forEach(element => {
          element.isView = true;
          element.widgetSize = element.widgetSize ? element.widgetSize : 6;
          element.widgetSizeTitle = this.widgetSizes.find(f => f.value === element.widgetSize).title;
        });
        this._widgets = items;
        this.getQueryResult();
      }
    }
  }

  constructor(private _queryGeneratorService: QueryGeneratorService) {
    super();

    this.widgetSizes = [
      { label: '2*2', value: 1, title: 'two-width two-height' },
      { label: '2*3', value: 2, title: 'two-width three-height' },
      { label: '2*4', value: 3, title: 'two-width four-height' },
      { label: '2*5', value: 4, title: 'two-width five-height' },

      { label: '3*2', value: 5, title: 'three-width two-height' },
      { label: '3*3', value: 6, title: 'three-width three-height' },
      { label: '3*4', value: 7, title: 'three-width four-height' },
      { label: '3*5', value: 8, title: 'three-width five-height' },

      { label: '4*2', value: 9, title: 'four-width two-height' },
      { label: '4*3', value: 10, title: 'four-width three-height' },
      { label: '4*4', value: 11, title: 'four-width four-height' },
      { label: '4*5', value: 12, title: 'four-width five-height' },

      { label: '5*2', value: 13, title: 'five-width two-height' },
      { label: '5*3', value: 14, title: 'five-width three-height' },
      { label: '5*4', value: 15, title: 'five-width four-height' },
      { label: '5*5', value: 16, title: 'five-width five-height' },
    ]
  }

  getQueryResult() {
    this._widgets.forEach((element) => {
      this._queryGeneratorService.executeQuery(element.QueryGeneratorId)
        .subscribe((data: any[]) => {
          if (data.length > 0)
            if (element.GeneratorType === GeneratorType.Chart) {
              this.generateChart(element, data)
            } else {
              element.information = data;
            }
        });
    });
  }

  generateChart(item, data) {
    let chart;
    switch (item.ChartType) {

      case ChartType.LineDottedChart:
        chart = am4core.create(item.generatedId, am4charts.XYChart);
        am4core.addLicense('ch-custom-attribution');
        this._microChart.createDottedLineChart(chart,
          am4charts,
          am4core,
          data,
          item.QueryGenerator.Title,
          item.HorizantalField,
          item.VerticalField
        );
        break;
      case ChartType.LineChart:
        chart = am4core.create(item.generatedId, am4charts.XYChart);
        am4core.addLicense('ch-custom-attribution');
        this._microChart.createSimpleLineChart(chart,
          am4charts,
          am4core,
          data,
          item.QueryGenerator.Title,
          item.HorizantalField,
          item.VerticalField
        );
        break;
      case ChartType.VerticalLineChart:
        chart = am4core.create(item.generatedId, am4charts.XYChart);
        am4core.addLicense('ch-custom-attribution');
        this._microChart.createVerticalLineChart(
          chart,
          am4charts,
          am4core,
          data,
          item.QueryGenerator.Title,
          item.HorizantalField,
          item.VerticalField
        );
        break;
      case ChartType.PieChart:
        chart = am4core.create(item.generatedId, am4charts.PieChart);
        am4core.addLicense('ch-custom-attribution');
        this._microChart.createPieChart(
          chart,
          am4charts,
          am4core,
          data,
          item.HorizantalField,
          item.VerticalField
        );
        break;
      case ChartType.PieChart3D:
        chart = am4core.create(item.generatedId, am4charts.PieChart3D);
        am4core.addLicense('ch-custom-attribution');
        this._microChart.create3DPieChart(
          chart,
          am4charts,
          am4core,
          data,
          item.HorizantalField,
          item.VerticalField
        );
        break;

      case ChartType.DottedMultipleValueChart:
        chart = am4core.create(item.generatedId, am4charts.XYChart);
        am4core.addLicense('ch-custom-attribution');
        this._microChart.createDottedMultipleValueChart(chart,
          am4charts,
          am4core,
          data,
          item.HorizantalField,
          item.VerticalField,
          item.RightField,
        );
        break;
      case ChartType.LineMultipleValueChart:
        chart = am4core.create(item.generatedId, am4charts.XYChart);
        am4core.addLicense('ch-custom-attribution');
        this._microChart.createLineMultipleValueChart(chart,
          am4charts,
          am4core,
          data,
          item.QueryGenerator.Title,
          item.HorizantalField,
          item.VerticalField,
          item.RightField,
        );
        break;
      default:
        return;
    }
  }

  onRemoveItem(item) {
    let items = [...this._widgets];
    items = this._widgets.filter(f => f != item);
    this._widgets = [...items];
    this.onSetResult.emit(this._widgets);
  }

  onToggleFullScreen(item) {
    let items = [...this._widgets];
    items.forEach(element => {
      if (element === item) {
        element.isFullScreen = element.isFullScreen ? false : true;
      } else {
        element.isFullScreen = false;
      }
    });
  }

  onToggleSettingScreen(item) {
    this.viewSettingScreen = true;

    this._widgets.forEach(element => {
      element.isView = element === item ? true : false;
    })
    this.selectedItem = item;
    this.selectedWidgetSize = this.widgetSizes.find(f => f.value === item.widgetSize).value;
  }

  onToggleCloseSettingScreen() {
    this.viewSettingScreen = false;
    this.selectedItem = null;
    this.selectedWidgetSize = null;

    this._widgets.forEach(element => {
      element.isView = true;
    })
  }

  ngOnInit() {

  }

  onChangeWidgetSize(event) {
    let selectedWidget = this.widgetSizes.find(f => f.value === event.value);

    this.selectedItem.widgetSize = selectedWidget.value;
    this.selectedItem.widgetSizeTitle = selectedWidget.title;

    this.onSetResult.emit(this._widgets);
  }
}